import CreateEditOfuCampaignContainerLegacy from '~/features/campaigns/components/ofuCreateEditContainerLegacy'

function OfuCreateCampaignPageLegacy() {
  return <CreateEditOfuCampaignContainerLegacy />
}

export default OfuCreateCampaignPageLegacy
